import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  Modal: {
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  Box: {
    width: '40%',
    height: 'max-content',
    minHeight: '30%',
    maxHeight: '75%',
    borderRadius: '12px',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
    transition: 'width 0.3s ease-in-out',
    '@media (max-width: 1280px)': {
      width: '60%',
    },
    '@media (max-width: 768px)': {
      width: '80%',
    },
  },
  Form: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)',
  },
  BoxHeader: {
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'stretch',
    background: 'var(--Base-White, #FFF)',
  },
  BoxContent: {
    display: 'flex',
    padding: '0 16px 16px',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: 'calc(100% - 150px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: '#f5f5f5',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555',
    },
  },
  BoxFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: ' 24px 16px 16px 16px',
    alignItems: 'flex-start',
    flex: '1 0 0',
  },
  BoxTitleModal: {
    borderRadius: '12px',
    display: 'flex',
    padding: ' 20px 16px 16px 16px',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '12px',
    background: 'var(--Base-White, #FFF)',
    alignSelf: 'stretch',
  },
  TitleModal: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignSelf: 'stretch',
  },
  IconClose: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
  },
  Items: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 14px',
    width: '100%',
    gap: '16px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid var(--Gray-300, #D0D5DD)',
    background: 'var(--Base-White, #FFF)',
  },
  CategoryName: {
    color: 'var(--Gray-900, #101828)',
    fontSize: '16px',
    lineHeight: '24px',
    width: '100%',
  },
  Icons: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  EditButton: {
    display: 'flex',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
  },
  EditButtonActive: {
    display: 'flex',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px solid var(--Primary-50, #F2FBF3)',
    background: 'var(--Primary-50, #F2FBF3)',
  },
  DeleteButtonActive: {
    display: 'flex',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px solid var(--Error-50, #FEF3F2)',
    background: 'var(--Error-50, #FEF3F2)',
  },
  Category: {
    display: 'flex',
    padding: '8px',
    gap: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}));

const buttonAddCategory = {
  display: 'flex',
  padding: '12px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  '&:hover': { backgroundColor: 'var(--Primary-50, #F2FBF3)' },
  borderRadius: '6px',
  border: '1px solid var(--Primary-50, #F2FBF3)',
  background: 'var(--Primary-50, #F2FBF3)',
};

const confirmButtonStyle = {
  display: 'flex',
  padding: '12px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  minWidth: '150px',
  flex: '1 0 0',
  borderRadius: '8px',
  border: '1px solid var(--Primary-600, #30893C)',
  background: 'var(--Primary-600, #30893C)',
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor: '#30893C' },
};

export { useStyles, confirmButtonStyle, buttonAddCategory };
